import { useEffect, useState } from "react";
import { createPortal } from "react-dom";

const Portal = ({ children }) => {
  const [mounted, setMounted] = useState(null);
  useEffect(() => {
    setMounted(true);
    return () => {
      setMounted(false);
    };
  }, []);
  console.log("mounted", mounted);

  return mounted && createPortal
    ? createPortal(children, document.getElementById("root"))
    : null;
};

export default Portal;
